import ThemeContext from "config/context/themeContext";
import { useContext, useState } from "react";
import GuiContext from "../../config/context/guiContext";
import GeneralSettings from "./components/GeneralSettings";
import PluginSettings from "./components/PluginSettings";
import styles from "./Settings.module.css";
import DocsSettings from "./components/DocsSettings";
import useTitle from "config/useTitle";

const Settings = () => {
  useTitle("Settings");
  const [preview, setPreview] = useState(1);
  const { userData } = useContext(GuiContext);
  const { dark: isDark } = useContext(ThemeContext);


  const previewContent = () => {
    switch (preview) {
      case 1:
        return <GeneralSettings />;
      case 2:
        return <PluginSettings />;
      case 3:
        return <DocsSettings />
      default:
        return null;
    }
  };

  return (
    <div
      className={`container ${styles.settings} ${isDark ? styles.dark : ""}`}
    >
      {/* <section className={`container ${styles.settingsSection}`}>
        <h1>Account: {userData.guiname}</h1>
        <h2>ID: {userData.id}</h2>
        <div className={`row ${styles.settingsGroup}`}>
          <GeneralSettings />
          <PluginSettings />
        </div>
        <div className={`row ${styles.settingsGroup}`}>
          <a target="_blank" href="http://localhost:8080/api/docs/">API Documentation</a>
        </div>
      </section>
      <AsideImg /> */}

      <div className={styles.settings_header}>
        <span>Account: {userData.guiname}</span>
        <span>ID: {userData.id}</span>
        <div className={styles.settings_header__actions}>
          <button onClick={() => setPreview(1)} className={`${preview === 1 ? styles.active : ''}`}>General settings</button>
          <button onClick={() => setPreview(2)} className={`${preview === 2 ? styles.active : ''}`}>Plugin settings</button>
          <button onClick={() => setPreview(3)} className={`${preview === 3 ? styles.active : ''}`}>Docs</button>
        </div>
        <hr />
      </div>
      <div className={styles.settings_body}>
        {previewContent()}
      </div>
    </div>
  );
};

export default Settings;
